import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import { HighlightedSelection } from 'apps/autocomplete/views/highlightedSelection';

// TODO - generalize autocomplete logic and move to common app (apps/autocomplete?)
@observer
export class AutocompleteDropdown extends React.Component {
  handleKeyDown = e => {
    const { manager } = this.props;
    const { selectedSuggestion, autocompleteVisible } = manager;
    const { PickSuggestion, DiscardSuggestion, SelectSuggestion } = manager;
    if (autocompleteVisible) {
      switch (e.key) {
        case 'ArrowDown':
          SelectSuggestion(selectedSuggestion + 1);
          e.preventDefault();
          break;
        case 'ArrowUp':
          SelectSuggestion(selectedSuggestion - 1);
          e.preventDefault();
          break;
        case 'Enter':
          PickSuggestion();
          e.preventDefault();
          break;
        case 'Escape':
          DiscardSuggestion();
          e.preventDefault();
          break;
        default:
          break;
      }
    }
  };

  componentDidMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  render() {
    const { manager, parent } = this.props;
    if (!parent) return null;
    const { params, users, selectedSuggestion, autocompleteVisible } = manager;
    if (!autocompleteVisible || !users.length) return null;
    const { PickSuggestion, SelectSuggestion } = manager;
    const username = params.username || '';

    return ReactDOM.createPortal(
      <Suggestions visible={autocompleteVisible}>
        {users.map((match, i) => {
          const { text } = match;
          return (
            <Suggestion
              key={match.id}
              selected={selectedSuggestion === i}
              onMouseEnter={() => {
                SelectSuggestion(i);
              }}
              onMouseDown={e => {
                e.preventDefault();
                PickSuggestion(text);
              }}
              handleKeyPress={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  PickSuggestion(text);
                }
              }}
            >
              <HighlightedSelection
                optionText={text}
                selection={username.substring(1)}
                inserveHighlighting
              />
            </Suggestion>
          );
        })}
      </Suggestions>,
      parent,
    );
  }
}

AutocompleteDropdown.propTypes = {
  manager: PropTypes.object,
  parent: PropTypes.object,
};

const Suggestions = styled.ul`
  display: ${props => (props.visible ? 'block' : 'none')};
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1000;
  ${props => props.top && `top: ${props.top}px`};
  ${props => props.left && `left: ${props.left}px`};
  background-color: ${props => props.theme.color.wfWhite};
  transition: opacity 0.75s;
  box-shadow: rgba(67, 90, 111, 0.416) 0px 0px 1px,
    rgba(67, 90, 111, 0.3) 0px 5px 8px -4px;
  overflow: auto;
`;

const Suggestion = styled.li`
  display: block;
  padding: 8px 12px 8px 6px;
  margin: 10px;
  min-width: 140px;
  color: ${props => props.theme.color.wfGrey};
  transition: padding 200ms ease-in-out;
  ${props =>
    props.selected &&
    `
    background-color: ${props.theme.color.primary};
    cursor: pointer;
    color: ${props.theme.color.wfWhite};
    padding: 8px 6px 8px 12px;
  `}
`;
